import React from 'react'
import { ToastContainer as DefaultContainer, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Styles from './Toast.styles'
import ToastCloseButton from './ToastCloseButton'

const ToastContainer: React.FC = () => (
  <>
    <Styles />
    <DefaultContainer
      position="bottom-right"
      closeButton={ToastCloseButton}
      autoClose={5000}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      icon={false}
      pauseOnFocusLoss
      pauseOnHover
      draggable
      limit={4}
      transition={Slide}
    />
  </>
)

export default ToastContainer
